import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthFeatureStateUnion, featureStateKey } from './state';
import { RoleEnum } from '../models';

const authFeatureSelector = createSelector(
  createFeatureSelector<AuthFeatureStateUnion>(featureStateKey),
  (state: AuthFeatureStateUnion) => state.auth
);

const currentUserSelector = createSelector(authFeatureSelector, (state) => state.currentUser);
const currentUserRoleSelector = createSelector(currentUserSelector, (currentUser) => currentUser?.role as RoleEnum);

export const AuthSelectors = {
  currentUserRoleSelector,
  currentUserSelector,
};
